import { ThunkDispatch } from "redux-thunk";
import { AnyAction } from "redux";
import { connect } from "react-redux";
import { RootState } from "../../../store";
import { Language } from "../../../client/api";
import { changeLanguage, refreshToken } from "../../../store/actions/userActions";
import { selectUserValue } from "../../../selectors";
import client from "../../../client";
import EventsSocket from "../../../client/Websockets/events";
import { AS_ENDPOINT } from "../../../config/constants";

const mapper = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({

  changeLanguageAction: (language: Language) => {
    changeLanguage(dispatch, language);
  },
  setEndpoint: (endpoint: string) => {
    client().setEndpoint(endpoint);
    EventsSocket.setEndpoint(endpoint);
    localStorage.setItem(AS_ENDPOINT, endpoint);
    refreshToken(dispatch);
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }
});

const props = (state: RootState) => ({
  user: selectUserValue(state)
});

export const connector = connect(props, mapper);
